var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contactNav"}},[_c('div',{staticClass:"contNavTitle"},[_c('div',[_vm._v("\n            联系我们\n        ")])])])
}]

export { render, staticRenderFns }